module.exports = __webpack_public_path__ + "img/logo.3ab33f9d.svg";